(function () {
  'use strict';

  var COPY = {
    nl: {
      eyebrow: 'MUSKLE · MJ App',
      title: 'Lichaamsdoel Calculator',
      intro:
        'Bereken je BMI, schat je vetpercentage en krijg praktische doelrichting op basis van je lichaamsmetingen.',
      accountNote: 'Geen account nodig. Log later in om je resultaat op te slaan.',
      backLabel: 'Terug naar MJ Apps',
      genderLabel: 'Geslacht',
      genderMale: 'Man',
      genderFemale: 'Vrouw',
      ageLabel: 'Leeftijd',
      agePlaceholder: 'Bijv. 32',
      heightLabel: 'Lengte (cm)',
      heightPlaceholder: 'Bijv. 178',
      weightLabel: 'Gewicht (kg)',
      weightPlaceholder: 'Bijv. 80',
      waistLabel: 'Taille (cm)',
      waistPlaceholder: 'Bijv. 82',
      neckLabel: 'Nek (cm)',
      neckPlaceholder: 'Bijv. 38',
      hipLabel: 'Heup (cm)',
      hipPlaceholder: 'Bijv. 98',
      goalLabel: 'Hoofddoel',
      goalFatLoss: 'Afvallen',
      goalMaintain: 'Onderhouden',
      goalBuild: 'Spiermassa opbouwen',
      goalRecomp: 'Body recomposition',
      calculateBtn: 'Bereken mijn lichaamsdoel',
      resultTitle: 'Jouw resultaat',
      resultEmpty: 'Vul je gegevens in en klik op berekenen om BMI, vetpercentage en doelrichting te zien.',
      bmiHeading: 'BMI',
      bodyFatHeading: 'Geschat vetpercentage',
      bodyFatNote:
        'Dit is een schatting op basis van omtrekmetingen, geen medische meting.',
      goalDirectionTitle: 'Doelrichting',
      bmiUnder: 'Ondergewicht',
      bmiHealthy: 'Gezond gewicht',
      bmiOver: 'Overgewicht',
      bmiObese: 'Obesitas',
      safetyNote:
        'Deze tool is bedoeld voor gezonde volwassenen. BMI is een eenvoudige screeningsmaat en vetpercentage is een schatting. Bij medische vragen, zwangerschap, eetproblemen of twijfel: overleg met een arts of diëtist.',
      sourceNote:
        'BMI-categorieën gebaseerd op volwassen BMI-richtlijnen zoals CDC. Vetpercentage wordt geschat met de U.S. Navy circumference method.',
      errorRequired:
        'Vul lengte, gewicht, taille en nek in om te berekenen.',
      errorHipRequired: 'Vul ook je heupomtrek in voor een vrouwelijke schatting.',
      errorWaistNeckMale: 'Taille moet groter zijn dan nek voor een geldige schatting.',
      errorWaistHipNeckFemale:
        'Taille plus heup moet groter zijn dan nek voor een geldige schatting.',
      errorInvalid: 'Controleer je invoer: alle waarden moeten geldige getallen zijn.',
      goalText: {
        fat_loss:
          'Focus op een haalbaar calorietekort, voldoende eiwit, krachttraining en dagelijkse beweging. Het doel is vetverlies ondersteunen terwijl je spiermassa zo goed mogelijk behoudt.',
        maintain:
          'Focus op stabiele gewoontes: voldoende eiwit, consistente maaltijden, regelmatige training en herstel. Je doel is je huidige lichaamsgewicht en samenstelling stabiel houden.',
        build_muscle:
          'Focus op krachttraining, voldoende eiwit en genoeg totale energie. Verwacht dat lichaamsgewicht langzaam kan stijgen; snelle stijging is niet altijd betere progressie.',
        recomposition:
          'Focus op langzaam verbeteren: genoeg eiwit, krachttraining, slaap en consistente voeding. Dit gaat meestal trager dan puur afvallen of puur spiermassa opbouwen.',
      },
    },
    en: {
      eyebrow: 'MUSKLE · MJ App',
      title: 'Body Goal Calculator',
      intro:
        'Calculate your BMI, estimate body fat and get practical goal direction based on your body measurements.',
      accountNote: 'No account needed. Later you can log in to save your result.',
      backLabel: 'Back to MJ Apps',
      genderLabel: 'Gender',
      genderMale: 'Male',
      genderFemale: 'Female',
      ageLabel: 'Age',
      agePlaceholder: 'e.g. 32',
      heightLabel: 'Height (cm)',
      heightPlaceholder: 'e.g. 178',
      weightLabel: 'Weight (kg)',
      weightPlaceholder: 'e.g. 80',
      waistLabel: 'Waist (cm)',
      waistPlaceholder: 'e.g. 82',
      neckLabel: 'Neck (cm)',
      neckPlaceholder: 'e.g. 38',
      hipLabel: 'Hip (cm)',
      hipPlaceholder: 'e.g. 98',
      goalLabel: 'Main goal',
      goalFatLoss: 'Fat loss',
      goalMaintain: 'Maintain',
      goalBuild: 'Build muscle',
      goalRecomp: 'Body recomposition',
      calculateBtn: 'Calculate my body goal',
      resultTitle: 'Your result',
      resultEmpty: 'Enter your details and click calculate to see BMI, body fat and goal direction.',
      bmiHeading: 'BMI',
      bodyFatHeading: 'Estimated body fat',
      bodyFatNote:
        'This is an estimate based on circumference measurements, not a medical measurement.',
      goalDirectionTitle: 'Goal direction',
      bmiUnder: 'Underweight',
      bmiHealthy: 'Healthy weight',
      bmiOver: 'Overweight',
      bmiObese: 'Obesity',
      safetyNote:
        'This tool is intended for healthy adults. BMI is a simple screening measure and body-fat percentage is an estimate. For medical questions, pregnancy, eating concerns or doubts: consult a doctor or dietitian.',
      sourceNote:
        'BMI categories are based on adult BMI guidance such as CDC. Body fat is estimated with the U.S. Navy circumference method.',
      errorRequired:
        'Enter height, weight, waist and neck to calculate.',
      errorHipRequired: 'Also enter hip circumference for a female estimate.',
      errorWaistNeckMale: 'Waist must be greater than neck for a valid estimate.',
      errorWaistHipNeckFemale:
        'Waist plus hip must be greater than neck for a valid estimate.',
      errorInvalid: 'Check your input: all values must be valid numbers.',
      goalText: {
        fat_loss:
          'Focus on a realistic calorie deficit, enough protein, strength training and daily movement. The goal is to support fat loss while preserving muscle as well as possible.',
        maintain:
          'Focus on stable habits: enough protein, consistent meals, regular training and recovery. Your goal is to keep your current body weight and composition stable.',
        build_muscle:
          'Focus on strength training, enough protein and enough total energy. Body weight may rise slowly; faster weight gain is not always better progress.',
        recomposition:
          'Focus on slow improvement: enough protein, strength training, sleep and consistent nutrition. This is usually slower than pure fat loss or pure muscle gain.',
      },
    },
  };

  function log10(value) {
    return Math.log(value) / Math.LN10;
  }

  function cmToIn(cm) {
    return cm / 2.54;
  }

  function parseNum(input) {
    var value = parseFloat(String(input).replace(',', '.'));
    return Number.isFinite(value) ? value : NaN;
  }

  function round1(value) {
    return Math.round(value * 10) / 10;
  }

  function calcBmi(weightKg, heightCm) {
    var heightM = heightCm / 100;
    return weightKg / (heightM * heightM);
  }

  function getBmiCategory(bmi, t) {
    if (bmi < 18.5) return t('bmiUnder');
    if (bmi < 25) return t('bmiHealthy');
    if (bmi < 30) return t('bmiOver');
    return t('bmiObese');
  }

  function calcBodyFatMale(waistCm, neckCm, heightCm) {
    var waistIn = cmToIn(waistCm);
    var neckIn = cmToIn(neckCm);
    var heightIn = cmToIn(heightCm);
    if (waistIn <= neckIn) return null;
    var inner = waistIn - neckIn;
    if (inner <= 0 || heightIn <= 0) return null;
    return 86.01 * log10(inner) - 70.041 * log10(heightIn) + 36.76;
  }

  function calcBodyFatFemale(waistCm, neckCm, hipCm, heightCm) {
    var waistIn = cmToIn(waistCm);
    var neckIn = cmToIn(neckCm);
    var hipIn = cmToIn(hipCm);
    var heightIn = cmToIn(heightCm);
    if (waistIn + hipIn <= neckIn) return null;
    var inner = waistIn + hipIn - neckIn;
    if (inner <= 0 || heightIn <= 0) return null;
    return 163.205 * log10(inner) - 97.684 * log10(heightIn) - 78.387;
  }

  function init(root) {
    if (!root || root.dataset.mjBodyGoalInit === '1') return;
    root.dataset.mjBodyGoalInit = '1';

    var lang = root.dataset.defaultLang === 'en' ? 'en' : 'nl';
    var els = {
      langBtns: root.querySelectorAll('[data-mj-lang]'),
      back: root.querySelector('[data-mj-copy="backLabel"]'),
      calculateBtn: root.querySelector('[data-mj-action="calculate"]'),
      resultEmpty: root.querySelector('[data-mj-result-empty]'),
      resultPanel: root.querySelector('[data-mj-result-panel]'),
      resultBmi: root.querySelector('[data-mj-result-bmi]'),
      resultBmiCategory: root.querySelector('[data-mj-result-bmi-category]'),
      resultBodyFat: root.querySelector('[data-mj-result-bodyfat]'),
      resultGoalTitle: root.querySelector('[data-mj-result-goal-title]'),
      resultGoalText: root.querySelector('[data-mj-result-goal-text]'),
      hipField: root.querySelector('[data-mj-hip-field]'),
      error: root.querySelector('[data-mj-error]'),
      age: root.querySelector('[data-mj-input="age"]'),
      height: root.querySelector('[data-mj-input="height"]'),
      weight: root.querySelector('[data-mj-input="weight"]'),
      waist: root.querySelector('[data-mj-input="waist"]'),
      neck: root.querySelector('[data-mj-input="neck"]'),
      hip: root.querySelector('[data-mj-input="hip"]'),
      gender: root.querySelectorAll('[data-mj-input="gender"]'),
      goal: root.querySelectorAll('[data-mj-input="goal"]'),
    };

    function t(key) {
      var parts = key.split('.');
      var val = COPY[lang];
      for (var i = 0; i < parts.length; i += 1) {
        if (!val) return key;
        val = val[parts[i]];
      }
      return val || key;
    }

    function getSelected(name) {
      var nodes = root.querySelectorAll('[data-mj-input="' + name + '"]');
      for (var i = 0; i < nodes.length; i += 1) {
        if (nodes[i].checked) return nodes[i].value;
      }
      return '';
    }

    function applyCopy() {
      root.querySelectorAll('[data-mj-copy]').forEach(function (node) {
        var key = node.getAttribute('data-mj-copy');
        if (!key || key === 'backLabel') return;
        var text = t(key);
        if (typeof text === 'string') node.textContent = text;
      });

      if (els.back) els.back.textContent = t('backLabel');
      if (els.calculateBtn) els.calculateBtn.textContent = t('calculateBtn');
      if (els.age) els.age.placeholder = t('agePlaceholder');
      if (els.height) els.height.placeholder = t('heightPlaceholder');
      if (els.weight) els.weight.placeholder = t('weightPlaceholder');
      if (els.waist) els.waist.placeholder = t('waistPlaceholder');
      if (els.neck) els.neck.placeholder = t('neckPlaceholder');
      if (els.hip) els.hip.placeholder = t('hipPlaceholder');

      root.querySelectorAll('[data-mj-option="gender"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'male') node.textContent = t('genderMale');
        if (opt === 'female') node.textContent = t('genderFemale');
      });

      root.querySelectorAll('[data-mj-option="goal"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'fat_loss') node.textContent = t('goalFatLoss');
        if (opt === 'maintain') node.textContent = t('goalMaintain');
        if (opt === 'build_muscle') node.textContent = t('goalBuild');
        if (opt === 'recomposition') node.textContent = t('goalRecomp');
      });

      els.langBtns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-mj-lang') === lang;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.classList.toggle('mj-app__lang-btn--active', isActive);
      });

      root.setAttribute('data-mj-lang', lang);
    }

    function syncGenderUi() {
      var gender = getSelected('gender') || 'male';
      var isFemale = gender === 'female';
      root.classList.toggle('mj-app--female', isFemale);
      if (els.hipField) els.hipField.hidden = !isFemale;
      if (els.hip && !isFemale) els.hip.value = '';
    }

    function showError(message) {
      if (!els.error) return;
      els.error.textContent = message;
      els.error.hidden = false;
    }

    function clearError() {
      if (!els.error) return;
      els.error.hidden = true;
      els.error.textContent = '';
    }

    function calculate() {
      clearError();

      var gender = getSelected('gender') || 'male';
      var goal = getSelected('goal') || 'maintain';
      var heightCm = parseNum(els.height && els.height.value);
      var weightKg = parseNum(els.weight && els.weight.value);
      var waistCm = parseNum(els.waist && els.waist.value);
      var neckCm = parseNum(els.neck && els.neck.value);
      var hipCm = parseNum(els.hip && els.hip.value);

      if (!heightCm || !weightKg || !waistCm || !neckCm) {
        showError(t('errorRequired'));
        return;
      }

      if (
        heightCm <= 0 ||
        weightKg <= 0 ||
        waistCm <= 0 ||
        neckCm <= 0 ||
        !Number.isFinite(heightCm) ||
        !Number.isFinite(weightKg) ||
        !Number.isFinite(waistCm) ||
        !Number.isFinite(neckCm)
      ) {
        showError(t('errorInvalid'));
        return;
      }

      if (gender === 'female' && (!hipCm || hipCm <= 0)) {
        showError(t('errorHipRequired'));
        return;
      }

      var bmi = calcBmi(weightKg, heightCm);
      var bodyFat = null;

      if (gender === 'male') {
        if (waistCm <= neckCm) {
          showError(t('errorWaistNeckMale'));
          return;
        }
        bodyFat = calcBodyFatMale(waistCm, neckCm, heightCm);
      } else {
        if (waistCm + hipCm <= neckCm) {
          showError(t('errorWaistHipNeckFemale'));
          return;
        }
        bodyFat = calcBodyFatFemale(waistCm, neckCm, hipCm, heightCm);
      }

      if (bodyFat === null || !Number.isFinite(bodyFat)) {
        showError(t('errorInvalid'));
        return;
      }

      if (els.resultBmi) els.resultBmi.textContent = String(round1(bmi));
      if (els.resultBmiCategory) {
        els.resultBmiCategory.textContent = getBmiCategory(bmi, t);
      }
      if (els.resultBodyFat) els.resultBodyFat.textContent = String(round1(bodyFat)) + '%';

      var goalTitleKey =
        goal === 'fat_loss'
          ? 'goalFatLoss'
          : goal === 'build_muscle'
            ? 'goalBuild'
            : goal === 'recomposition'
              ? 'goalRecomp'
              : 'goalMaintain';
      if (els.resultGoalTitle) els.resultGoalTitle.textContent = t(goalTitleKey);
      if (els.resultGoalText) els.resultGoalText.textContent = t('goalText.' + goal);

      if (els.resultEmpty) els.resultEmpty.hidden = true;
      if (els.resultPanel) els.resultPanel.hidden = false;
      root.classList.add('mj-app--has-result');
    }

    els.langBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-mj-lang');
        if (next === 'nl' || next === 'en') {
          lang = next;
          applyCopy();
          if (root.classList.contains('mj-app--has-result')) calculate();
        }
      });
    });

    els.gender.forEach(function (input) {
      input.addEventListener('change', syncGenderUi);
    });

    if (els.calculateBtn) {
      els.calculateBtn.addEventListener('click', calculate);
    }

    applyCopy();
    syncGenderUi();
  }

  document.querySelectorAll('[data-mj-body-goal-app]').forEach(init);
})();
